var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBouclier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 37.715,
    viewBox: "0 0 33 37.715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_117",
    "data-name": "Groupe 117",
    transform: "translate(-1487 -68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_26",
    "data-name": "Groupe 26",
    transform: "translate(1487 68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_340",
    "data-name": "Rectangle 340",
    width: 8,
    height: 3,
    transform: "translate(16 32.714)",
    fill: "#94354d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_341",
    "data-name": "Rectangle 341",
    width: 2,
    height: 2,
    transform: "translate(24 30.714)",
    fill: "#94354d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 2,
    height: 2,
    transform: "translate(26 28.714)",
    fill: "#94354d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_343",
    "data-name": "Rectangle 343",
    width: 3,
    height: 3,
    transform: "translate(28 25.714)",
    fill: "#94354d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 8,
    height: 3,
    transform: "translate(9 32.714)",
    fill: "#de6333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 2,
    height: 2,
    transform: "translate(7 30.714)",
    fill: "#de6333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 2,
    height: 2,
    transform: "translate(5 28.714)",
    fill: "#de6333"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_347",
    "data-name": "Rectangle 347",
    width: 3,
    height: 3,
    transform: "translate(2 25.714)",
    fill: "#de6333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_116",
    "data-name": "Trac\\xE9 116",
    d: "M1,8v7.071H3.357v2.357H5.714v2.357H8.071v2.357h7.071V8Z",
    transform: "translate(1.357 10.857)",
    fill: "#eb933b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_348",
    "data-name": "Rectangle 348",
    width: 15,
    height: 14,
    transform: "translate(16 4.714)",
    fill: "#eb933b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_117",
    "data-name": "Trac\\xE9 117",
    d: "M7,8V22.143h7.071V19.786h2.357V17.429h2.357V15.071h2.357V8Z",
    transform: "translate(9.5 10.857)",
    fill: "#ab3c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_349",
    "data-name": "Rectangle 349",
    width: 14,
    height: 14,
    transform: "translate(2 4.714)",
    fill: "#ab3c3c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_350",
    "data-name": "Rectangle 350",
    width: 15,
    height: 2,
    transform: "translate(16 2.714)",
    fill: "#ffdf75"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_351",
    "data-name": "Rectangle 351",
    width: 14,
    height: 2,
    transform: "translate(2 2.714)",
    fill: "#d96262"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_352",
    "data-name": "Rectangle 352",
    width: 15,
    height: 2,
    transform: "translate(9 35.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_353",
    "data-name": "Rectangle 353",
    width: 2,
    height: 3,
    transform: "translate(24 32.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_354",
    "data-name": "Rectangle 354",
    width: 2,
    height: 3,
    transform: "translate(7 32.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_355",
    "data-name": "Rectangle 355",
    width: 2,
    height: 2,
    transform: "translate(26 30.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_356",
    "data-name": "Rectangle 356",
    width: 2,
    height: 2,
    transform: "translate(5 30.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 3,
    height: 2,
    transform: "translate(28 28.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 3,
    height: 2,
    transform: "translate(2 28.714)",
    fill: "#45283c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_118",
    "data-name": "Trac\\xE9 118",
    d: "M0,0V28.288H2.357V2.357H30.643V28.288H33V0Z",
    fill: "#45283c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_119",
    "data-name": "Trac\\xE9 119",
    transform: "translate(1497 80.714)",
    fill: "#fafafa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 13.99979972839355 13.00030040740967 L 12.99979972839355 13.00030040740967 L 10.99979972839355 13.00030040740967 L 9.999799728393555 13.00030040740967 L 9.999799728393555 12.00030040740967 L 8.999799728393555 12.00030040740967 L 8.999799728393555 11.00030040740967 L 7.999799728393555 11.00030040740967 L 7.999799728393555 10.00030040740967 L 7.000799655914307 10.00030040740967 L 6.000799655914307 10.00030040740967 L 6.000799655914307 11.00030040740967 L 5.000799655914307 11.00030040740967 L 4.999799728393555 11.00030040740967 L 4.999799728393555 12.00030040740967 L 3.999799728393555 12.00030040740967 L 3.999799728393555 13.00030040740967 L 2.999799728393555 13.00030040740967 L 0.9997997283935547 13.00030040740967 L -0.0002002716064453125 13.00030040740967 L -0.0002002716064453125 12.00030040740967 L -0.0002002716064453125 10.00030040740967 L -0.0002002716064453125 9.000300407409668 L 0.9997997283935547 9.000300407409668 L 0.9997997283935547 8.000300407409668 L 1.999799728393555 8.000300407409668 L 1.999799728393555 7.000300407409668 L 2.999799728393555 7.000300407409668 L 2.999799728393555 5.999300479888916 L 2.999799728393555 5.000300407409668 L 1.999799728393555 5.000300407409668 L 1.999799728393555 4.000300407409668 L 0.9997997283935547 4.000300407409668 L 0.9997997283935547 3.000300407409668 L -0.0002002716064453125 3.000300407409668 L -0.0002002716064453125 2.000300407409668 L -1.000200271606445 2.000300407409668 L -1.000200271606445 1.000300407409668 L -1.000200271606445 0.0003004074096679688 L -1.000200271606445 -0.999699592590332 L -0.0002002716064453125 -0.999699592590332 L 2.999799728393555 -0.999699592590332 L 3.999799728393555 -0.999699592590332 L 3.999799728393555 0.0003004074096679688 L 4.999799728393555 0.0003004074096679688 L 4.999799728393555 1.000300407409668 L 5.000799655914307 1.000300407409668 L 6.000799655914307 1.000300407409668 L 6.000799655914307 2.000300407409668 L 7.000799655914307 2.000300407409668 L 7.999799728393555 2.000300407409668 L 7.999799728393555 1.000300407409668 L 8.999799728393555 1.000300407409668 L 8.999799728393555 0.0003004074096679688 L 9.999799728393555 0.0003004074096679688 L 9.999799728393555 -0.999699592590332 L 10.99979972839355 -0.999699592590332 L 12.99979972839355 -0.999699592590332 L 13.99979972839355 -0.999699592590332 L 13.99979972839355 0.0003004074096679688 L 13.99979972839355 2.000300407409668 L 13.99979972839355 3.000300407409668 L 12.99979972839355 3.000300407409668 L 12.99979972839355 4.000300407409668 L 11.99979972839355 4.000300407409668 L 11.99979972839355 5.000300407409668 L 10.99979972839355 5.000300407409668 L 10.99979972839355 5.999300479888916 L 10.99979972839355 7.000300407409668 L 11.99979972839355 7.000300407409668 L 11.99979972839355 8.000300407409668 L 12.99979972839355 8.000300407409668 L 12.99979972839355 9.000300407409668 L 13.99979972839355 9.000300407409668 L 13.99979972839355 10.00030040740967 L 13.99979972839355 12.00030040740967 L 13.99979972839355 13.00030040740967 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -0.0002002716064453125 0.0003004074096679688 L -0.0002002716064453125 1.000300407409668 L 0.9997997283935547 1.000300407409668 L 0.9997997283935547 2.000300407409668 L 1.999799728393555 2.000300407409668 L 1.999799728393555 3.000300407409668 L 2.999799728393555 3.000300407409668 L 2.999799728393555 4.000300407409668 L 3.999799728393555 4.000300407409668 L 3.999799728393555 4.999300479888916 L 5.000799655914307 4.999300479888916 L 5.000799655914307 5.999300479888916 L 3.999799728393555 5.999300479888916 L 3.999799728393555 8.000300407409668 L 2.999799728393555 8.000300407409668 L 2.999799728393555 9.000300407409668 L 1.999799728393555 9.000300407409668 L 1.999799728393555 10.00030040740967 L 0.9997997283935547 10.00030040740967 L 0.9997997283935547 12.00030040740967 L 2.999799728393555 12.00030040740967 L 2.999799728393555 11.00030040740967 L 3.999799728393555 11.00030040740967 L 3.999799728393555 10.00030040740967 L 5.000799655914307 10.00030040740967 L 5.000799655914307 9.000300407409668 L 6.000799655914307 9.000300407409668 L 6.000799655914307 8.000300407409668 L 7.999799728393555 8.000300407409668 L 7.999799728393555 9.000300407409668 L 8.999799728393555 9.000300407409668 L 8.999799728393555 10.00030040740967 L 9.999799728393555 10.00030040740967 L 9.999799728393555 11.00030040740967 L 10.99979972839355 11.00030040740967 L 10.99979972839355 12.00030040740967 L 12.99979972839355 12.00030040740967 L 12.99979972839355 10.00030040740967 L 11.99979972839355 10.00030040740967 L 11.99979972839355 9.000300407409668 L 10.99979972839355 9.000300407409668 L 10.99979972839355 8.000300407409668 L 9.999799728393555 8.000300407409668 L 9.999799728393555 5.999300479888916 L 8.999799728393555 5.999300479888916 L 8.999799728393555 4.999300479888916 L 9.999799728393555 4.999300479888916 L 9.999799728393555 4.000300407409668 L 10.99979972839355 4.000300407409668 L 10.99979972839355 3.000300407409668 L 11.99979972839355 3.000300407409668 L 11.99979972839355 2.000300407409668 L 12.99979972839355 2.000300407409668 L 12.99979972839355 0.0003004074096679688 L 10.99979972839355 0.0003004074096679688 L 10.99979972839355 1.000300407409668 L 9.999799728393555 1.000300407409668 L 9.999799728393555 2.000300407409668 L 8.999799728393555 2.000300407409668 L 8.999799728393555 3.000300407409668 L 7.999799728393555 3.000300407409668 L 7.999799728393555 4.000300407409668 L 6.000799655914307 4.000300407409668 L 6.000799655914307 3.000300407409668 L 5.000799655914307 3.000300407409668 L 5.000799655914307 2.000300407409668 L 3.999799728393555 2.000300407409668 L 3.999799728393555 1.000300407409668 L 2.999799728393555 1.000300407409668 L 2.999799728393555 0.0003004074096679688 L -0.0002002716064453125 0.0003004074096679688 M -2.000200271606445 -1.999699592590332 L 4.999799728393555 -1.999699592590332 L 4.999799728393555 -0.999699592590332 L 5.999799728393555 -0.999699592590332 L 5.999799728393555 0.0003004074096679688 L 7.999799728393555 0.0003004074096679688 L 7.999799728393555 -0.999699592590332 L 8.999799728393555 -0.999699592590332 L 8.999799728393555 -1.999699592590332 L 14.99979972839355 -1.999699592590332 L 14.99979972839355 4.000300407409668 L 13.99979972839355 4.000300407409668 L 13.99979972839355 5.000300407409668 L 12.99979972839355 5.000300407409668 L 12.99979972839355 7.000300407409668 L 13.99979972839355 7.000300407409668 L 13.99979972839355 8.000300407409668 L 14.99979972839355 8.000300407409668 L 14.99979972839355 14.00030040740967 L 8.999799728393555 14.00030040740967 L 8.999799728393555 13.00030040740967 L 7.999799728393555 13.00030040740967 L 7.999799728393555 12.00030040740967 L 5.999799728393555 12.00030040740967 L 5.999799728393555 13.00030040740967 L 4.999799728393555 13.00030040740967 L 4.999799728393555 14.00030040740967 L -1.000200271606445 14.00030040740967 L -1.000200271606445 8.000300407409668 L -0.0002002716064453125 8.000300407409668 L -0.0002002716064453125 7.000300407409668 L 0.9997997283935547 7.000300407409668 L 0.9997997283935547 6.000300407409668 L 1.999799728393555 6.000300407409668 L 0.9997997283935547 6.000300407409668 L 0.9997997283935547 5.000300407409668 L -0.0002002716064453125 5.000300407409668 L -0.0002002716064453125 4.000300407409668 L -1.000200271606445 4.000300407409668 L -1.000200271606445 3.000300407409668 L -2.000200271606445 3.000300407409668 L -2.000200271606445 -1.999699592590332 Z",
    stroke: "none",
    fill: "#ab3c3c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBouclier);
export default __webpack_public_path__ + "static/media/bouclier.37bedec57f75f1f245b5c4a68d7be79f.svg";
export { ForwardRef as ReactComponent };